export default class ReleaseNote {
    public RecId: number | null = null;
    public ShortFormText: string | null = null;
    public LongFormText: string | null = null;
    public NoticeDate: Date | null = null;
    public NoteDescription: string | null = null;

    constructor() {
        this.NoticeDate = new Date();
    }
}
